import { render, staticRenderFns } from "./premium-feature-icon.vue?vue&type=template&id=68ea7efc&scoped=true"
import script from "./premium-feature-icon.vue?vue&type=script&lang=js"
export * from "./premium-feature-icon.vue?vue&type=script&lang=js"
import style0 from "./premium-feature-icon.vue?vue&type=style&index=0&id=68ea7efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea7efc",
  null
  
)

export default component.exports